module.exports = __webpack_public_path__ + "static/phone-49e28af701e4ff701f56b4c68c09ccf3.png";